var _defs, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreatments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 21,
    viewBox: "0 0 87 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#011d29;font-size:16px;font-family:DMSans-Medium, DM Sans;font-weight:500;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "a",
    transform: "translate(0 16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Treatments"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatments);
export default __webpack_public_path__ + "static/media/Treatments.1703ea666a119c6f4954e5411fc13d0c.svg";
export { ForwardRef as ReactComponent };